<template>
	<div>
		<transition name="modal">
			<div class="modal-mask">
				<div class="modal-wrapper" @click="closeModal">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
							<div class="modal-container" @click.stop>
								<div class="modal-body">
									<div class="">
										<h1 style="font-size: 25px;">Login Sebagai Admin Untuk Memakai Fitur Tersebut.</h1>
										<p style="font-size:13px;color:red">{{reason}}</p>
										<!-- <p style="background-color:red;font-weight:bold;padding:5px" v-if="error != ''">{{error}}</p> -->
										<div class="form">
										<div class="mt-4">
											<label class="sr-only">Username</label>
											<div class="input-group mb-2">
											<div class="input-group-prepend">
												<div class="input-group-text" style="background-color: #FCC514; width:60px;">
												<i class="fas fa-user fa-2x" style="margin: 0 auto;"></i>
												</div>
											</div>
											<input v-model="user.username" type="text" placeholder="Username" class="form-control login-input" @keyup.enter="login">
											</div>
										</div>
										<div class="mt-4">
											<label class="sr-only">Password</label>
											<div class="input-group mb-2">
											<div class="input-group-prepend">
												<div class="input-group-text" style="background-color: #FCC514; width:60px;">
												<i class="fas fa-key fa-2x" style="margin: 0 auto;"></i>
												</div>
											</div>
											<input v-model="user.password" type="password" placeholder="Password" class="form-control login-input" @keyup.enter="login">
											</div>
										</div>
										</div>
										<div class="row mt-4">
											<div class="col" style="display: flex; flex-direction: row-reverse;" :class="(mobile) ? '' : 'mr-5'">
												<div :style="(mobile) ? 'width: 100%' : 'width: 20%'" >
												<button type="button" class="btn btn-success w-100" style="font-size: 100%;" @click="requestApproval">Menyetujui</button>
												</div>
												<div :style="(mobile) ? 'width: 100%' : 'width: 20%'" class="mr-3">
												<button type="button" class="btn btn-danger w-100" style="font-size: 100%;" @click="closeModal">Batal</button>
												</div>
												
												
											</div>
										</div>
                    
									</div>
                  <!-- <hr> -->
                  <div>
                    <div class="row mt-3">
                      <div class="col-5">
                        <hr>
                      </div>
                      <div class="col-2">
                        <h4 class="text-center">OR</h4>
                      </div>
                      <div class="col-5">
                        <hr>
                      </div>
                    </div>
                    <h4>Request for Admin Approval</h4>
                    <p style="color:red">{{message}}</p>
                    <div v-if="!request_id">
                      
                      <button class="btn btn-info mt-3" @click="insertRequestApproval">Click Here to Request</button>
                    </div>
                    <div v-else>
                      <p>Wait for the Admin to approve / deny your request. Do not close this modal</p>
                    </div>
                  </div>
								</div>
							</div>
						</div>
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data () {
		return {
			user : {
				username : '',
				password : ''
			},
			mobile : this.isMobile(),
      request_id : null,
      interval : null,
      message : null
		}
	},
  	props: [
		'reason',
    'request'
	],
	mounted () {
		
	},
	methods: {
		requestApproval() {
			this.$http.post('/api/v1/auth' , this.user)
			.then((resp) => {
				let token = resp.data.data.token

				this.$emit('token' , token)
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Username or Password is Invalid'])
			})
		},
    insertRequestApproval () {
      this.$http.post('/api/v1/check' , {request : this.request})
      .then((resp) => {
        // console.log(resp.data.data)
        let data = resp.data.data
        this.request_id = data.insertId

        this.interval = setInterval(() => {
          this.$http.get('/api/v1/check/' + this.request_id)
          .then((resp) => {
            let data = resp.data.data
            if(data.status == 'APPROVED'){
              clearInterval(this.interval)
              this.$emit('approved' , null , null)
            }
            else if(data.status == 'REJECTED') {
              clearInterval(this.interval)
              this.request_id = null
              this.message = 'Request Has Been Denied. Please Try Again.'
            }
             
          })
          .catch((err) => {
            console.log(err)
          })
        }, 5000)
        
      })
      .catch((err) => {
        this.$store.dispatch('triggerAlert' , [false , 'Something went wrong. Please try again later.'])
      })
    },
    closeModal() {
      if(this.request_id) {
        this.$http.delete('/api/v1/check/' + this.request_id)
          .then((resp) => {
            this.$emit('closeModal') 
          })
          .catch((err) => {
            console.log(err)
          })
      }
      else {
        this.$emit('closeModal') 
      }
      
    }
    
	}
}
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
    margin:0
  }

  .modal-body .moduleLine{
    margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
    text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
    background-color: #E0E0E0;
    transition: background-color 0.7s ease;
    color: #212121;
    transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
    border:1px solid #BDBDBD;
    border-radius: 20px;
    padding: 20px 0;
    color:black;
    margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
    font-size:5vh;
  }

  h3.modalHeadline{
    margin:0 0 20px 0
  }
  /* MODAL ENDS */

  .modalContent tr th{
    text-align:right;
  }

  .modalContent tr .middleDivider{
    width: 50px;
    text-align: center;
  }
</style>

<style scoped>
  #login{
    height: 100vh;
    background: url('~@/assets/img/Login/background2.jpg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 100% auto;
    position: relative;
  }

  .toCenter{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .wid50{ width: 50vw; }
  .wid90{ width: 90vw; }

  #loginShade{
    position: absolute;
    top:50%; left:50%;
    transform: translate(-50%, -50%);

    height: 400px;

    margin: 0 auto;

    background-color: black;
    opacity: 0.5;
    border-radius: 7px;
  }

  #loginBox{
    position: absolute;
    top:50%; left:50%;
    transform: translate(-50%, -50%);

    height: 400px;

    margin: 0 auto;
    padding: 2%;
    color:white;
  }

  .login-input{
    height:50px;
  }

  .login-input::placeholder{
    font-size: 130%;
    font-weight: bold;
  }
</style>